import { useMemo } from "react";
import {
    useCurrentOrganizationMembers,
    useOrganizationClientUsers,
} from "@api/organizationMember.api";
import type { OrganizationClientUser } from "@common/schemas/domains/organizationMember/organization-client-user.schema";

export type OrganizationActivityPerson = OrganizationClientUser;

/** Firm members, then every client user: the people the org Activity page can name by id. */
export function useOrganizationActivityPeople(): OrganizationActivityPerson[] {
    const { data: members } = useCurrentOrganizationMembers();
    const { data: clientUsers } = useOrganizationClientUsers();

    return useMemo(
        () => [
            ...(members ?? []).map(({ user }) => user),
            ...(clientUsers ?? []),
        ],
        [members, clientUsers],
    );
}
